import './styles.css'

export * from './components'

export * from './widgets'

export * from './misc'

export * from './layouts'

export * from './icons'
export {onTouchDoubleTap} from './ui'
export {main as MainTheme, StorybookTheme, cssVariables} from './themes'

import './polyfills'


// WEBPACK FOOTER //
// ./src/shared/components/ui/index.ts